import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { FormGroup, Label, Input } from 'reactstrap';
import {reserve,payMeth } from '../../../slices/modalSlice';
import { connect } from 'react-redux';
import BasicDocument, { MyDocument } from '../pdfGenerator';
import ReactDOM from 'react-dom';
import ReactPDF from '@react-pdf/renderer';
import pdfReservationHebergSlice, { showPdf } from '../../../slices/pdfReservationHebergSlice';
import { reservation } from '../../../slices/reservationHebergSlice';



class HebergReserv extends Component {

    constructor(props) {
        super(props);
        this.state = {
          modalReserve:false,
          annonceType : "" ,
          annonceId : "" ,
          pdf : false ,

          bebe   :  [] ,
          enfant :  [] ,
          adult  :  []
        };
    
        this.toggle = this.toggle.bind(this);
      }

    toggle() {
        this.setState({
          modalReserve: false
        });
      }
    toogleClose = () =>{
        this
        .props
        .dispatch(reserve())
    }
    payMeth = () =>{
      this.props.dispatch(payMeth())
    }
  

    pay = () => {
     this.toogleClose();
     this.payMeth()
  }


  onInputChange(evt) {
    const persType = evt.target.attributes.data.value
    const index = evt.target.attributes.index.value
    const name = evt.target.name
    const copie = this.state[persType]
    copie[index]= {...copie[index] , [name] : evt.target.value}

		this.setState({
				[persType]: copie
		})
	}
  submitReservation(){
    this.props.dispatch(reservation(this.state))
    this.props.dispatch(showPdf());
  }

  persInputs(i,type){
    // type 0 = bebe ; type 1 = enfant ; type 2 = adult ;
    return (<>
        <p className="textUpborder">{i+1} ème Personne  {type===0 && "(Enfant 2-12 ans)"} {type===1 && "(Bébé 0-2 ans)"}</p>
        <form onChange={e=>this.onInputChange(e)}> 
        <div className="reserveDivs">
            <div className="row">
               {(type ===2) && <FormGroup className="d-flex col-12 col-md-2">
                 <label for="exampleSelect" className="col-form-label mr-0  ">Civ</label>
                 <Input className="reserveInput" type="select" name="gender" index={i} data={type===0 && "enfant" || type===1 && "bebe" || type===2 && "adult"}>
                  <option>Mr.</option>
                  <option>Mme.</option>
                  <option>Mlle.</option>
                 </Input>
               </FormGroup>}
               <FormGroup className="d-flex col-12 col-md-5">
                 <label className="col-form-label ml-md-2 mr-2">Nom</label>
                 <Input className="reserveInput" type="text" index={i} data={type===0 && "enfant" || type===1 && "bebe" || type===2 && "adult"} name="nom"  placeholder="Nom" />
               </FormGroup>
               <FormGroup className="d-flex col-12 col-md-5">
                 <label className="col-form-label mr-2">Prénom</label>
                 <Input className="reserveInput" type="text" index={i} data={type===0 && "enfant" || type===1 && "bebe" || type===2 && "adult"} name="prenom"  placeholder="Prénom" />
               </FormGroup>
            </div> 
            <div className="row mt-2">
               <FormGroup className="d-flex col-12">
                 <label className="col-form-label mr-2">Date de naissance</label>
                 <Input className="reserveInput col-md-4" index={i} data={type===0 && "enfant" || type===1 && "bebe" || type===2 && "adult"} type="date" name="birthDay" />
               </FormGroup>
            </div>
        </div>
        </form>
        </>
    )
  }
    render() {

      const adult = this.props.persons.nbrAdulte; 
      const bebe = this.props.persons.nbrChildren
      const enfant = 0;

      const adultElm = [] ;
      const enfantElm = [] ;
      const bebeElm = [] ;

      for (let i = 0; i < adult; i++) {
        adultElm.push(this.persInputs(i,2))
      }
      for (let i = 0; i < enfant; i++) {
        enfantElm.push(this.persInputs(i,1))
      }
      for (let i = 0; i < bebe; i++) {
        bebeElm.push(this.persInputs(i,0))
      }

      const pdf = this.props.pdf
      return (
            <div>
              {!pdf && <Modal isOpen={this.props.reserve} toggle={this.toogleClose} contentClassName="reserveModal" centered={true} size="lg">
                   <ModalHeader className="modalHeader" toggle={this.toogleClose}><center className="text-center ml-md-3">Réserver maintenant-Hébergement</center></ModalHeader>
                   <ModalBody className="container">
                      <p className="textUpborder">Vos coordonnées</p>
                      <div className="reserveDivs">
                         
                           <div className="row">
                             <FormGroup className="d-flex col-12 col-md-2">
                               <label for="exampleSelect" className="col-form-label mr-1">Civ</label>
                               <Input className="reserveInput" type="select" name="select" id="exampleSelect">
                                <option>Mr.</option>
                                <option>Mme.</option>
                                <option>Mlle.</option>
                               </Input>
                             </FormGroup>
                             <FormGroup className="d-flex col-12 col-md-5">
                               <label className="col-form-label ml-md-3 mr-2">Nom</label>
                               <Input className="reserveInput" type="text" name="nom"  placeholder="Nom" />
                             </FormGroup>
                             <FormGroup className="d-flex col-12 col-md-5">
                               <label className="col-form-label mr-2">Prénom</label>
                               <Input className="reserveInput" type="text" name="prenom"  placeholder="Prénom" />
                             </FormGroup>
                           </div> 
                           <div className="row mt-2">
                             <FormGroup className="d-flex col-12 col-md-6">
                               <label for="exampleSelect" className="col-form-label">Numéro</label>
                               <div className="row">
                               <Input className="reserveInput col-3 offset-1 mr-1" type="select" name="select" id="exampleSelect">
                                <option>+213</option>
                                <option>+120</option>
                                <option>+390</option>
                               </Input>
                               <Input className="reserveInput col-7" type="tel" id="phone" name="phone"
                                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"   />
                                </div>
                             </FormGroup>
                             <FormGroup className="d-flex col-12 col-md-6">
                               <label for="exampleSelect" className="col-form-label mr-2">Nationalité</label>
                               <Input className="reserveInput" type="select" name="select" id="exampleSelect">
                                <option>Algérienne</option>
                                <option>Francaise</option>
                                <option>Américaine</option>
                               </Input>
                             </FormGroup>
                           </div>
                           <div className="row mt-2">
                             <FormGroup className="d-flex col-12">
                               <label className="col-form-label mr-2">Date de naissance</label>
                               <Input className="reserveInput col-md-4" type="date" name="prenom"  placeholder="Prénom" />
                             </FormGroup>
                           </div>
                           <div className="row mt-2">
                             <FormGroup className="d-flex col-12 col-md-6">
                               <label className="col-form-label mr-2">Numéro du doc. de voyage</label>
                               <Input className="reserveInput col-7 col-md-6" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"   />
                             </FormGroup>
                             <FormGroup className="d-flex col-12 col-md-6">
                               <label className="col-form-label mr-2">Date d'expération</label>
                               <Input className="reserveInput col-8 col-md-8" type="date" name="prenom"  placeholder="Prénom" />
                             </FormGroup>
                           </div>
                      </div>
                      {
                        adultElm.map(e=>{
                          return e
                        })
                      }
                      
                      {
                        enfantElm.map(e=>{
                          return e
                        })
                      }

                      {
                        bebeElm.map(e=>{
                          return e
                        })
                      }
                      <p className="textUpborder">Conditions générales</p>
                      <div className="reserveDivs">
                           <FormGroup  check>
                              <Label check>
                              <Input type="checkbox" />{' '}
                              J'ai bien vérifié que les noms/prénoms des voyageurs sont bien orthographiés et correspondent aux noms/prénoms indiqués sur le passeport/
                               document de voyage lors de l'enregistrement
                              </Label>
                           </FormGroup>
                           <FormGroup className="reserveChecks" check>
                              <Label check>
                              <Input type="checkbox" />{' '}
                              J'ai bien vérifié que l'adresse e-mail sur laquelle je souhaite recevoir tous mes documents de voyage est correcte, ainsi que le numéro de 
                               téléphone que j'ai indiqué (toute erreur peut entrainer des frais supplémentaires)
                              </Label>
                           </FormGroup>
                           <FormGroup className="reserveChecks" check>
                              <Label check>
                              <Input type="checkbox" />{' '}
                              Je suis en régle avec les autorités locales (et de transit le cas échéant) pour les formalités de police, de douane et de santé, et j'ai pris 
                               connaissance des conditions relatives aux émissions de CO2
                              </Label>
                           </FormGroup>
                           {/*
                           <div className="d-flex justify-content-end">
                             <ReserveBtn className="d-flex reserveConf" color="#015573" height="40px" width="50%" content="Confirmer votre réservation" icon="/imgs/resrervationIcons/reserverMaintenant.svg"  event="baridi"/>
                           </div>*/}
                           {/* <button className="d-flex reserveConf" onClick={this.pay}>Confirmer votre réservation */}
                           <button className="d-flex reserveConf" onClick={e=>this.submitReservation()}>Confirmer votre réservation
                             <i id="reserveIcon">
                               <svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 58.98 52.006">
                                 <path id="Path_581" data-name="Path 581" d="M901.8,613.8l-3.391-3.748-10.377,9.387a25.72,25.72,0,1,0,2.943,4.154Zm-12.515,22.5a20.741,20.741,0,1,1-5-13.47l-17.541,15.867-6.561-6.965L856.5,635.2l9.958,10.57,20.653-18.682A20.568,20.568,0,0,1,889.284,636.3Z" transform="translate(-842.819 -610.051)" fill="#fff"/>
                               </svg>
                             </i>
                           </button>
                           
                        
                      </div>
                      
                   </ModalBody>
              </Modal>}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
      reserve:  state.modal.resv,
      pdf :state.showReservationHeberg.showPdf,
      persons : state.reservationHeberg.person
    }
  }


export default connect(mapStateToProps)(HebergReserv);
